import type { ErrorMap } from '@/app/error-registry';

export const CLIENTS_ERROR_MAP: ErrorMap = {
  POST: {
    'Client.AlreadyExists': 'clients:apiErrors.alreadyExists',
    'Client.ContactsRequired': 'clients:apiErrors.contactsRequired',
    'Client.NoPrimaryContact': 'clients:apiErrors.noPrimaryContact',
    'Client.MultiplePrimaryContacts': 'clients:apiErrors.multiplePrimaryContacts',
    'TaxId.Empty': 'clients:apiErrors.taxIdEmpty',
    'TaxId.TooShort': 'clients:apiErrors.taxIdTooShort',
    'TaxId.TooLong': 'clients:apiErrors.taxIdTooLong',
    'TaxId.InvalidFormat': 'clients:apiErrors.taxIdInvalidFormat',
    default: 'clients:apiErrors.createDefault',
  },
  PUT: {
    'Client.NotFound': 'clients:apiErrors.notFound',
    'Client.AlreadyExists': 'clients:apiErrors.alreadyExists',
    'Client.ContactsRequired': 'clients:apiErrors.contactsRequired',
    'Client.NoPrimaryContact': 'clients:apiErrors.noPrimaryContact',
    'Client.MultiplePrimaryContacts': 'clients:apiErrors.multiplePrimaryContacts',
    'TaxId.Empty': 'clients:apiErrors.taxIdEmpty',
    'TaxId.TooShort': 'clients:apiErrors.taxIdTooShort',
    'TaxId.TooLong': 'clients:apiErrors.taxIdTooLong',
    'TaxId.InvalidFormat': 'clients:apiErrors.taxIdInvalidFormat',
    default: 'clients:apiErrors.updateDefault',
  },
  DELETE: {
    'Client.NotFound': 'clients:apiErrors.notFound',
    'Client.HasMembers': 'clients:apiErrors.hasMembers',
    default: 'clients:apiErrors.deleteDefault',
  },
};
